<script setup lang="ts">
/**
 * MarkdownDisplay — Read-only markdown renderer with inline widget support.
 *
 * Thin wrapper around MarkdownWidgetDisplay. All existing consumers
 * (AnnouncementDetail, CRUD fields, etc.) automatically get widget support.
 * Content without tokens renders identically to the previous implementation.
 */
import MarkdownWidgetDisplay from '@ja/core-ui/composites/inline-widgets/MarkdownWidgetDisplay.vue'

defineProps<{
  content?: string | null
  class?: string
}>()
</script>

<template>
  <MarkdownWidgetDisplay :content="content" :class="$props.class" />
</template>
